import { shutdown } from '@intercom/messenger-js-sdk';

export const intercomShutdown = () => {
  if (typeof shutdown !== 'function') {
    return;
  }

  try {
    shutdown();
  } catch (err) {
    console.error('Intercom shutdown error:', err);
  }
};
